export default "__VITE_ASSET__pWZUoCNK__"